export const TASK_RESCHEDULE_LABEL = 'Reschedule';
